import React from "react";
import Lottie from "react-lottie";
import * as BirthdayPopper from "./BirthdayPopper.json";

export default function BirthdayPopperComp() {
  const buttonStyle = {
    display: "block",
    margin: "10px auto",
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: BirthdayPopper,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return <Lottie options={defaultOptions} height={"10em"} width={"18em"} />;
}
